import {Activity, ArrowRight} from 'lucide-react'

const COLS = [
  {
    title: 'Calculator',
    links: [
      { label: 'Shred Calculator', href: '#calculator' },
      { label: 'Macro Split', href: '#calculator' },
      { label: 'FFMI & Water', href: '#calculator' },
    ],
  },
  {
    title: 'Plans',
    links: [
      { label: 'Meal Planner', href: '#meals' },
      { label: 'Workout Builder', href: '#workout' },
      { label: 'PDF Blueprint', href: '#calculator' },
    ],
  },
  {
    title: 'Learn',
    links: [
      { label: 'Shred Guide', href: '#guide' },
      { label: 'FAQ', href: '#faq' },
      { label: 'Get a ripped body', href: '#guide' },
    ],
  },
]

function Footer() {
  return (
    <footer className="relative border-t border-white/[0.06] bg-[#08090d]">
      {/* CTA band */}
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
        <div className="relative overflow-hidden rounded-3xl border border-blue-500/20 bg-gradient-to-br from-blue-600/15 to-transparent p-8 sm:p-12 text-center">
          <div
            className="absolute -top-20 left-1/2 -translate-x-1/2 w-72 h-72 rounded-full blur-3xl opacity-40"
            style={{ background: 'radial-gradient(circle,#2563eb,transparent 70%)' }}
            aria-hidden="true"
          />
          <h2 className="relative font-display text-[28px] sm:text-[36px] font-bold tracking-[-0.02em] text-white">
            Ready to get ripped?
          </h2>
          <p className="relative mt-3 text-[16px] text-slate-400 max-w-md mx-auto">
            Run the numbers, lock your macros, and download your lean and ripped body blueprint in
            seconds.
          </p>
          <a
            href="#calculator"
            className="relative mt-7 inline-flex items-center gap-2 rounded-full bg-white text-[#0a0c10] px-7 py-3.5 text-[15px] font-semibold hover:bg-blue-500 hover:text-white transition-colors"
          >
            Calculate My Shred
            <ArrowRight className="w-5 h-5" aria-hidden="true" />
          </a>
        </div>
      </div>

      {/* Links */}
      <div className="max-w-7xl mx-auto px-5 sm:px-8 pb-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <a href="#top" className="flex items-center gap-2.5" aria-label="ShredCalculator home">
            <span className="grid place-items-center w-9 h-9 rounded-xl bg-blue-600">
              <Activity className="w-5 h-5 text-white" aria-hidden="true" />
            </span>
            <span className="font-display font-bold text-[17px] text-white">
              Shred<span className="text-blue-500">Calculator</span>
            </span>
          </a>
          <p className="mt-4 text-[13px] leading-relaxed text-slate-500 max-w-xs">
            The premium scientific shred calculator for anyone chasing a lean ripped body. Free,
            private, and built on real exercise science.
          </p>
        </div>

        {COLS.map((c) => (
          <div key={c.title}>
            <h3 className="text-[13px] font-semibold uppercase tracking-wide text-slate-300">
              {c.title}
            </h3>
            <ul className="mt-4 space-y-2.5">
              {c.links.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    className="text-[14px] text-slate-500 hover:text-white transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="border-t border-white/[0.06]">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[13px] text-slate-600">
            © {new Date().getFullYear()} ShredCalculator.com — Lean to ripped, the smart way.
          </p>
          <p className="text-[12px] text-slate-600 max-w-md text-center sm:text-right">
            For educational use only. Consult a professional before major diet or training changes.
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
